import React from 'react';

import ConfigureFormContainer from './ConfigureFormContainer';

const ConfigureFormPage = () => (
  <div className="container extra-wide-table">
    <div className="row">
      <div className="col-md-12">
        <div className="card card-block">
          <h2 className="card-title">Configure For Platform</h2>
          <ConfigureFormContainer />
        </div>
      </div>
    </div>
  </div>
);

export default ConfigureFormPage;
